import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Button, Input } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { useStores } from "../../models";
import { ToastError } from "../../components/Toast";

const usdtImg = require("../../assets/images/wallet/usdt.png");
const nbcoinImg = require("../../assets/images/wallet/nbcoin.png");

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  background: rgb(247, 248, 255);
  padding: 12px;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
`;

const Title = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
  margin-bottom: 12px;
`;

const Field = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  gap: 10px;
`;

const Rate = styled.div`
  margin: 8px 0 16px;
  font-size: 14px;
`;

const Exchange = () => {
  const { navigate } = useNavigation();
  const { apiStore, authStore } = useStores();
  const [quantities, setQuantities] = useState("");
  const [nbcoinQuantities, setNbcoinQuantities] = useState("");
  const [rate, setRate] = useState(7.14);
  const [minUsdt, setMinUsdt] = useState(0);
  const [loading, setLoading] = useState(false);

  const getConfig = async () => {
    try {
      setLoading(true);
      const res = await apiStore.getExchangeRate({ token: authStore.getToken });
      setRate(res?.usdt_rate ?? res?.data?.usdt_rate ?? 7.14);
      setMinUsdt(res?.min_usdt ?? res?.data?.min_usdt ?? 0);
    } catch (e: any) {
      ToastError(e?.message || "获取汇率失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onUsdtChange = (text: string) => {
    if (text === "" || !Number(text)) {
      setQuantities("");
      setNbcoinQuantities("");
      return;
    }
    if (/^[0-9]+(\.[0-9]{0,2})?$/.test(text)) {
      let v = text;
      if (Number(v) > 1000000) v = "999999";
      setQuantities(Number(v).toString());
      setNbcoinQuantities(Number((Number(v) * rate).toFixed(2)).toString());
    }
  };

  const onNbChange = (text: string) => {
    if (text === "" || !Number(text)) {
      setQuantities("");
      setNbcoinQuantities("");
      return;
    }
    if (/^[0-9]+(\.[0-9]{0,2})?$/.test(text)) {
      let usdt = (Number(text) / rate).toFixed(2);
      let nb = text;
      if (Number(usdt) > 1000000) {
        usdt = "999999";
        nb = (Number(usdt) * rate).toFixed(2);
      }
      setNbcoinQuantities(Number(nb).toString());
      setQuantities(Number(usdt).toString());
    }
  };

  const handleBuy = async () => {
    if (!Number(quantities)) return ToastError("请输入正确数量");
    if (Number(quantities) < minUsdt)
      return ToastError("USDT数量不可小于" + minUsdt);
    try {
      setLoading(true);
      const res = await apiStore.createExchange({
        token: authStore.getToken,
        usdt: Number(quantities),
        usdt_rate: rate,
      });
      const data = res?.data || res;
      if (data) {
        navigate("ExchangeDetail", {
          ex_order_no: data.ex_order_no,
          usdt_rand: Number(data.usdt_rand).toFixed(2),
          usdt_trc: data.usdt_trc,
          amount: Number(data.amount).toFixed(2),
        });
      }
    } catch (e: any) {
      ToastError(e?.message || "创建订单失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrap>
      <PageHeader title="USDT充值" />
      <ScrollArea>
        <Card>
          <Title>USDT-TRC20</Title>
          <Field>
            <img src={usdtImg} alt="" width={28} height={28} />
            <Input
              value={quantities}
              onChange={onUsdtChange}
              placeholder={`最小充值 ${minUsdt} USDT`}
              style={{ flex: 1, background: "#f7f8ff", padding: 8 }}
            />
          </Field>
          <Field>
            <img src={nbcoinImg} alt="" width={28} height={28} />
            <Input
              value={nbcoinQuantities}
              onChange={onNbChange}
              placeholder="将获得喜鹊币数量"
              style={{ flex: 1, background: "#f7f8ff", padding: 8 }}
            />
          </Field>
          <Rate>
            当前汇率：<span style={{ color: "#1c9cea", fontWeight: 700 }}>{rate}</span>
          </Rate>
          <Button color="primary" block loading={loading} onClick={handleBuy}>
            立即充值
          </Button>
        </Card>
      </ScrollArea>
    </PageWrap>
  );
};

export default observer(Exchange);
